import type { T_Symbol, T_Timeframe } from '@/ts/types/T_Chart';

export const TF_LIST: T_Timeframe[] = ['1H', '6H', '12H', '1D'];
export const TF_LIST_POOL: T_Timeframe[] = [
  '1H',
  '6H',
  '12H',
  '1D',
  '1M',
  'ALL'
];
export const SYMBOLS: T_Symbol[] = ['BTC', 'ETH', 'SOL', 'XRP'];
export const LS_KEY = 'chart_tf_prediction' as string;
